

<div class="card">
  <div class="card-content">

    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalCategoriesCount }}</span>
          <span class="stats-card-label">Categories</span>
          <span class="stats-card-sublabel">Total groups</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-list"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ currentMonthAvailable }}</span>
          <span class="stats-card-label">Available Now</span>
          <span class="stats-card-sublabel">This month</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-users"></i></div>
      </div>
      <div class="stats-card stats-card--warning">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ highlightedMonthsCount }}</span>
          <span class="stats-card-label">Active Months</span>
          <span class="stats-card-sublabel">With availability</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-calendar"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ showingCount }}</span>
          <span class="stats-card-label">Showing</span>
          <span class="stats-card-sublabel">After filters</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-filter"></i></div>
      </div>
    </div>

    <!-- Report Table -->
    <div class="report-table-container">
      <p-table
        [scrollable]="true"
        scrollHeight="flex"
        [value]="filteredReportData"
        [loading]="loading"
        [tableStyle]="{ 'min-width': '100%' }"
        styleClass="p-datatable no-column-lines compact-striped-table availability-table fill-height">
        
        <ng-template pTemplate="header">
          <tr>
            <th rowspan="2" class="category-header">Category</th>
            <th colspan="12" class="title-header">No. of Available Members</th>
          </tr>
          <tr>
            <th class="month-header">Jan</th>
            <th class="month-header">Feb</th>
            <th class="month-header">Mar</th>
            <th class="month-header">Apr</th>
            <th class="month-header">May</th>
            <th class="month-header">Jun</th>
            <th class="month-header">Jul</th>
            <th class="month-header">Aug</th>
            <th class="month-header">Sep</th>
            <th class="month-header">Oct</th>
            <th class="month-header">Nov</th>
            <th class="month-header">Dec</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
          <tr [class.total-row]="rowData.categoryId === 'total'">
            <td class="category-cell">
              <strong *ngIf="rowData.categoryId === 'total'">{{ rowData.categoryName }}</strong>
              <span *ngIf="rowData.categoryId !== 'total'">{{ rowData.categoryName }}</span>
            </td>
            <td [class.highlight-cell]="shouldHighlight(rowData.jan)" class="value-cell"
              [pTooltip]="getCellTooltip(rowData.jan, rowData.categoryId, rowData.categoryName, 'jan', 'Jan')" tooltipPosition="top">
              {{ formatValue(rowData.jan) }}
            </td>
            <td [class.highlight-cell]="shouldHighlight(rowData.feb)" class="value-cell"
              [pTooltip]="getCellTooltip(rowData.feb, rowData.categoryId, rowData.categoryName, 'feb', 'Feb')" tooltipPosition="top">
              {{ formatValue(rowData.feb) }}
            </td>
            <td [class.highlight-cell]="shouldHighlight(rowData.mar)" class="value-cell"
              [pTooltip]="getCellTooltip(rowData.mar, rowData.categoryId, rowData.categoryName, 'mar', 'Mar')" tooltipPosition="top">
              {{ formatValue(rowData.mar) }}
            </td>
            <td [class.highlight-cell]="shouldHighlight(rowData.apr)" class="value-cell"
              [pTooltip]="getCellTooltip(rowData.apr, rowData.categoryId, rowData.categoryName, 'apr', 'Apr')" tooltipPosition="top">
              {{ formatValue(rowData.apr) }}
            </td>
            <td [class.highlight-cell]="shouldHighlight(rowData.may)" class="value-cell"
              [pTooltip]="getCellTooltip(rowData.may, rowData.categoryId, rowData.categoryName, 'may', 'May')" tooltipPosition="top">
              {{ formatValue(rowData.may) }}
            </td>
            <td [class.highlight-cell]="shouldHighlight(rowData.jun)" class="value-cell"
              [pTooltip]="getCellTooltip(rowData.jun, rowData.categoryId, rowData.categoryName, 'jun', 'Jun')" tooltipPosition="top">
              {{ formatValue(rowData.jun) }}
            </td>
            <td [class.highlight-cell]="shouldHighlight(rowData.jul)" class="value-cell"
              [pTooltip]="getCellTooltip(rowData.jul, rowData.categoryId, rowData.categoryName, 'jul', 'Jul')" tooltipPosition="top">
              {{ formatValue(rowData.jul) }}
            </td>
            <td [class.highlight-cell]="shouldHighlight(rowData.aug)" class="value-cell"
              [pTooltip]="getCellTooltip(rowData.aug, rowData.categoryId, rowData.categoryName, 'aug', 'Aug')" tooltipPosition="top">
              {{ formatValue(rowData.aug) }}
            </td>
            <td [class.highlight-cell]="shouldHighlight(rowData.sep)" class="value-cell"
              [pTooltip]="getCellTooltip(rowData.sep, rowData.categoryId, rowData.categoryName, 'sep', 'Sep')" tooltipPosition="top">
              {{ formatValue(rowData.sep) }}
            </td>
            <td [class.highlight-cell]="shouldHighlight(rowData.oct)" class="value-cell"
              [pTooltip]="getCellTooltip(rowData.oct, rowData.categoryId, rowData.categoryName, 'oct', 'Oct')" tooltipPosition="top">
              {{ formatValue(rowData.oct) }}
            </td>
            <td [class.highlight-cell]="shouldHighlight(rowData.nov)" class="value-cell"
              [pTooltip]="getCellTooltip(rowData.nov, rowData.categoryId, rowData.categoryName, 'nov', 'Nov')" tooltipPosition="top">
              {{ formatValue(rowData.nov) }}
            </td>
            <td [class.highlight-cell]="shouldHighlight(rowData.dec)" class="value-cell"
              [pTooltip]="getCellTooltip(rowData.dec, rowData.categoryId, rowData.categoryName, 'dec', 'Dec')" tooltipPosition="top">
              {{ formatValue(rowData.dec) }}
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr class="table-empty-row">
            <td colspan="13" class="table-empty-cell">
              <div class="empty-state">
                <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                <p class="empty-message">No data available</p>
                <p class="empty-description">Try changing the year to view availability data</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>
</div>

<!-- Chart Dialog -->
<p-dialog
  [(visible)]="displayChartDialog"
  [modal]="true"
  [style]="{'width': '90vw', 'max-width': '1200px'}"
  [draggable]="false"
  [resizable]="true"
  header="Allocation vs Availability"
  [closable]="true"
  (onShow)="onChartDialogShow()">

  <!-- Filters inside dialog -->
  <div class="flex justify-content-start align-items-center gap-3 mb-3">
    <div class="field mb-0">
      <label for="chartCategory" class="control-label">Category</label>
      <p-select
        id="chartCategory"
        [(ngModel)]="selectedCategoryId"
        (ngModelChange)="onChartCategoryChange()"
        [options]="categoryOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="All Categories"
        [filter]="true"
        filterPlaceholder="Search category..."
        [style]="{'width': '180px'}"
        appendTo="body">
      </p-select>
    </div>
  </div>

  <div class="chart-wrapper-dialog">
    <!-- Loading skeleton shown while data is fetching -->
    <div *ngIf="chartLoading" class="chart-loading-state">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem; color: var(--primary-color)"></i>
      <span style="margin-top: 0.75rem; color: var(--text-color-secondary); font-size: var(--font-size-sm)">Loading chart data…</span>
    </div>
    <p-chart
      *ngIf="!chartLoading"
      type="line"
      [data]="chartData"
      [options]="chartOptions"
      [style]="{'width': '100%', 'height': '500px'}">
    </p-chart>
  </div>
</p-dialog>

